import { AnimatePresence } from "framer-motion";
import React from "react";

type Props = {
  enabled: boolean;
} & React.ComponentProps<typeof AnimatePresence>;

export default function ConditionalAnimatePresence(props: Props) {
  return props.enabled ? <AnimatePresence {...props} /> : <>{props.children}</>;
}
